import Modal from "../../components/atoms/Modal";
import InputGroup from "../../components/atoms/InputGroup";
import SelectModal from "../../components/atoms/SelectModal";
import BtnModal from "../../components/atoms/BtnModal";
import React, {useEffect, useState} from "react";
import {useClientContext} from "../client/ClientContext";
import useAdminContext from "./AdminsContext";
import modal from "../../components/atoms/Modal";
import toast from "react-hot-toast";
import {isNumeric} from "../../tools/tools";

const AddAdminModal = () => {
    const {
        addUpdateAdmin,
        closeModal,
        modalState
    } = useAdminContext();
    const accessValues = [
        {value: "مدیرکل", label: "مدیرکل"},
        {value: "برنامه نویس", label: "برنامه نویس"},
    ];
    const statusValues = [
        {value: "فعال", label: "فعال"},
        {value: "غیر فعال", label: "غیر فعال"},
    ];

    const isEdit = modalState.mode === 'edit';
    const isOpen = modalState.mode !== "delete" && modalState.isOpen;
    const initState = {
        name: '', number: '', password: '', access: "", status: "",
    };
    const [formData, setFormData] = useState(initState);
    const btnTitle = !isEdit ? "تایید اطلاعات و افزودن" : "تایید اطلاعات و ویرایش";
    const title = !isEdit ? "افزودن مدیر " : `ویرایش مدیر "${modalState.selectedItem.name}"`;

    useEffect(() => {
        if (isEdit) {
            const { pin, ...rest } = modalState.selectedItem;
            setFormData({
                ...rest,
                password: pin
            });

        } else {
            setFormData(initState);
        }
    }, [modalState]);

    if (!isOpen) return null;
    const handleInputChange = (field, value) => {

        setFormData(prev => ({...prev, [field]: value}));
    };
    const handleSubmit = () => {
        if (formData.name.trim().length === 0 || formData.number.trim().length === 0) {
            // Check if name or number is empty
            toast.error("مشخصات خود را کامل کنید", {
                className: "text-12 text-dark-blue-200",
            });
            return;
        } else if (!isNumeric(formData.number)) {
            // Check if number is not numeric
            toast.error("شماره خود را صحیح وارد کنید", {
                className: "text-12 text-dark-blue-200",
            });
            return;
        }
        if (modalState.mode === "edit") {

            addUpdateAdmin({
                id: modalState.selectedItem.id,
                ...formData
            })
        } else {
            addUpdateAdmin(formData)
        }
        closeModal()
    };
    return (
        <>
            {/* Modal component */}

            <Modal title={title} closeModal={closeModal}>
                {/* Modal body */}
                <div className="flex flex-col ">
                    <InputGroup
                        placeholder="مانند علی میرهادی"
                        label={"نام و نام خانوادگی"}
                        val={formData.name}
                        iconName={"userF"}
                        onchange={(event) => handleInputChange("name", event.target.value)}
                        id={"name"}
                    />
                    <InputGroup
                        placeholder="مانند 09175843681"
                        label={"شماره تماس"}
                        val={formData.number}
                        iconName={"call"}
                        onchange={(event) => handleInputChange("number", event.target.value)}
                        id={"number"}
                        type={"text"}
                    />
                    <InputGroup
                        placeholder="مانند 1234"
                        label={"پین"}
                        val={formData.password}
                        iconName={"discover"}
                        onchange={(event) => handleInputChange("password", event.target.value)}
                        id={"password"}
                        type={"text"}
                    />
                    <SelectModal
                        label={"سطح دسترسی"}
                        iconName={"level"}
                        defaultO={formData.access}
                        values={accessValues}
                        onchange={(event) => {
                            handleInputChange("access", event[0].value)
                            // console.log("EVENT SELECT : ",event)
                        }}
                        able={!isEdit}
                        wbox="326px"
                        placeholder={"یک گزینه را انتخاب کنید"}
                    />
                    <SelectModal
                        label={"وضعیت"}
                        iconName={"profile-circle"}
                        defaultO={formData.status}
                        values={statusValues}
                        onchange={(event) => {
                            // console.log("EVENT SELECT : ",event)

                            handleInputChange("status", event[0].value);

                        }}
                        able={!isEdit}
                        wbox="326px"
                        placeholder={"یک گزینه را انتخاب کنید"}
                    />
                </div>
                {/*footer*/}
                <div className="flex justify-end pt-2">
                    <BtnModal
                        text={btnTitle}
                        accept={handleSubmit}
                        disabled={!formData.name || !formData.number}
                    />
                </div>
            </Modal>
            {/* Background overlay */}
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
    );
}
export default AddAdminModal